import React from "react";
import "./KidsLogin.css";

export default function Login({
    username, setUsername,
    password, setPassword,
    handleLogin,
    error, setError
  }) {
    return (
        <div className="login-body">

            <div className="login-container">
                <div className="login-card">
                    <h1 className="login-title">Welcome to
                        <br />School Shala!</h1>
                    <p className="login-subtitle">A fun place to learn computers & coding!</p>
                    <form className="login-form" onSubmit={handleLogin}>
                        <input
                            type="text"
                            placeholder="Username"
                            className="login-input"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            className="login-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <button type="submit" className="login-button">
                            Let's Go!
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}  
